<template>
  <div>
    <div class="row">
      <div class="col-6" />
      <div class="col-6" style="text-align: right">
        <md-button class="md-primary md-raised" @click="$router.back()">
          Voltar
        </md-button>
      </div>
    </div>
    <div class="md-content md-table md-theme-default">
      <div class="md-content md-table-content md-scrollbar md-theme-default">
        <table>
          <transition-group name="flip-list" tag="tbody">
            <tr :key="-1" class="md-table-row flip-list">
              <th class="md-table-head">
                <div class="md-table-head-container">
                  <div class="md-table-head-label">Identificação</div>
                </div>
              </th>
              <th class="md-table-head">
                <div class="md-table-head-container">
                  <div class="md-table-head-label">Ultimo envio</div>
                </div>
              </th>
              <th class="md-table-head">
                <div class="md-table-head-container">
                  <div class="md-table-head-label">Proxima tentativa</div>
                </div>
              </th>
              <th class="md-table-head">
                <div class="md-table-head-container md-ripple md-disabled">
                  <div class="md-table-head-label" />
                </div>
              </th>
            </tr>

            <tr
              v-for="notificacao in notificacoes"
              :key="notificacao.id"
              class="md-table-row flip-list"
            >
              <td class="md-table-cell">
                <div class="md-table-cell-container">
                  <p>{{ notificacao.identificacao }}</p>
                </div>
              </td>
              <td class="md-table-cell">
                <div class="md-table-cell-container">
                  {{ formatDate(notificacao.dataUltimoEnvio) }}
                </div>
              </td>
              <td class="md-table-cell">
                <div class="md-table-cell-container">
                  {{ formatDate(notificacao.proximaTentativa) }}
                </div>
              </td>
              <td class="md-table-cell">
                <div class="md-table-cell-container">
                  <router-link
                    v-if="isAdmin()"
                    :to="{
                      name: 'NotificacaoLogDetalhe',
                      params: {
                        localId: localId,
                        notificacaoId: notificacao.id,
                      },
                    }"
                  >
                    <md-button class="md-"> Detalhes </md-button>
                  </router-link>
                </div>
              </td>
            </tr>
          </transition-group>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

import { EventBus, Topics, Types } from '@/event-bus'
import auth from '@/utils/auth'

import http from '../../../utils/http'
import socket from '../../../utils/web-socket'

export default {
  name: 'NotificacaoLogIndex',
  data() {
    return {
      loading: false,
      notificacoes: [],
      channel: null,
    }
  },
  beforeMount() {
    this.localId = this.$route.params.localId
  },
  beforeDestroy() {
    this.channel.leave()
  },
  async mounted() {
    const jwtToken = http.auth.updateRefreshToken()

    await this.loadNotificacoes()

    this.channel = socket.channel('notification_log:' + this.localId, {
      token: jwtToken,
    })

    this.channel
      .join()
      // eslint-disable-next-line no-unused-vars
      .receive('error', (resp) => {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Não foi possível conectar em tempo real',
        })
      })

    // eslint-disable-next-line no-unused-vars
    this.channel.on('notificacao:update', async (payload) => {
      await this.loadNotificacoes()
    })
  },
  methods: {
    isAdmin: auth.isAdmin,
    async loadNotificacoes() {
      if (this.loading === true) {
        return
      }

      this.loading = true

      this.notificacoes = (
        await http.get(`local/${this.localId}/notificacoes`, {
          orderByDataAtivacao: true,
        })
      ).notificacoes

      this.loading = false
    },
    formatDate(string) {
      if (!string) {
        return '-'
      }

      return moment
        .tz(string, 'UTC')
        .tz(moment.tz.guess())
        .format('D/MM/YYYY à\\s H:mm:ss')
    },
  },
}
</script>

<style scoped lang="scss">
.flip-list-move {
  transition: transform 1s;
}

.flip-list {
  margin-right: 10px;
}

.flip-list-enter-active,
.list-leave-active {
  transition: all 1s;
}

.flip-list-enter, .flip-list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>
